import { Controller } from "@hotwired/stimulus"

// Auto-detect browser timezone and language, pre-select matching options
// Only fills in selects that have no value (or a blank/default value)
export default class extends Controller {
  static targets = ["timezone", "locale"]
  connect() {
    if (this.hasTimezoneTarget) this.detectTimezone()
    if (this.hasLocaleTarget) this.detectLocale()
  }

  detectTimezone() {
    const select = this.timezoneTarget
    // Skip if user already has a value set
    if (select.value && select.value !== "") return

    try {
      const iana = Intl.DateTimeFormat().resolvedOptions().timeZone
      if (!iana) return

      // Select values are IANA identifiers, match directly
      if (this.hasOption(select, iana)) {
        select.value = iana
      }
    } catch (_) {
      // Browser doesn't support Intl API
    }
  }

  detectLocale() {
    const select = this.localeTarget
    // Skip if user already has a value set
    if (select.value && select.value !== "") return

    try {
      const browserLang = navigator.language // e.g. "zh-CN", "en-US", "ja"
      if (!browserLang) return

      // Try exact match first (e.g. "zh-CN" → "zh-CN")
      if (this.hasOption(select, browserLang)) {
        select.value = browserLang
        return
      }

      // Try base language (e.g. "en-US" → "en")
      const base = browserLang.split("-")[0]
      if (this.hasOption(select, base)) {
        select.value = base
      }
    } catch (_) {
      // Browser doesn't support navigator.language
    }
  }

  hasOption(select, value) {
    return Array.from(select.options).some(opt => opt.value === value)
  }
}
